<template>
  <div class="spareRequirements lianchulianbei_check wr-sjz">
    <div class="container">
      <Breadcrumb :pageTitle="pageTitle" />
      <CurrentState :dataForm="dataForm">
        <div slot="btns" class="btns">
          <el-button
            size="medium"
            class="default-btn"
            v-if="dataForm.status === 0"
            @click="handleDelete"
          >
            {{$t('delete')}}
          </el-button>
          <el-button
            type="primary"
            size="medium"
            v-if="dataForm.status === 0"
            @click="toUpdate"
          >
            {{$t('update')}}
          </el-button>
          <el-button
            size="medium"
            class="default-btn"
            v-if="dataForm.status === 1"
            :loading="cancelLoading"
            @click="handleCancel"
          >
            {{$t('cancel')}}
          </el-button>
          <el-button
            type="primary"
            size="medium"
            v-if="dataForm.status === 1"
            :loading="subLoading"
            @click="handleSave"
          >
            {{$t('confirm')}}
          </el-button>
          <el-button
            type="primary"
            size="medium"
            v-if="dataForm.status === 5 || dataForm.status === 6"
            @click="pingjiaclick"
          >
            {{ dataForm.status === 6 ? $t('orderlist.btn7') : $t('orderlist.btn6') }}
          </el-button>
        </div>
      </CurrentState>
      <div class="body-info">
        <h2 class="title">{{$t('account.basicInfo')}}</h2>
        <BaseInfo :dataForm="dataForm" />
        <el-form
          :model="dataForm"
          :inline="true"
          ref="dataForm"
          label-width="140px"
          class="demo-form-inline"
        >
          <h2 class="title">{{$t('stockNeed.spareNeedInformation')}}</h2>
          <el-row>
            <el-table
              :data="dataForm.demandDetailList"
              border
              style="width: 100%"
            >
              <el-table-column
                type="index"
                width="50"
                align="center"
                :label="$t('product.id')"
              ></el-table-column>
              <el-table-column
                prop="oldGoodsCode"
                header-align="center"
                align="center"
                :label="$t('product.codes')"
              >
              </el-table-column>
              <el-table-column
                prop="oldGoodsName"
                header-align="center"
                align="center"
                width="160px"
                :label="$t('model.name')"
              >
              </el-table-column>
              <el-table-column
                min-width="110"
                prop="oldSpecification"
                header-align="center"
                align="center"
                :label="$t('common.specification')"
              >
              </el-table-column>
              <el-table-column
                prop="oldModel"
                header-align="center"
                align="center"
                :label="$t('common.model')"
              >
              </el-table-column>
              <el-table-column
                prop="brand"
                header-align="center"
                align="center"
                :label="$t('common.brand')"
              >
              </el-table-column>
              <!-- <el-table-column
                prop="oldRemark"
                header-align="center"
                align="center"
                label="备注"
                width="160"
              >
              </el-table-column> -->
              <el-table-column
                prop="safetyStockQuantityBef"
                header-align="center"
                align="center"
                :label="$t('stockNeed.appliedAmount')"
              >
              </el-table-column>
              <el-table-column
                prop="sellingUnit"
                header-align="center"
                align="center"
                :label="$t('common.unit')"
              >
                <template slot-scope="scope">
                  {{ scope.row.sellingUnit || '-' }}
                </template>
              </el-table-column>
              <el-table-column
                prop="price"
                header-align="center"
                align="center"
                :label="$t('cart.agreementPrice')"
              >
              </el-table-column>
              <el-table-column
                prop="lclbCommodityType"
                header-align="center"
                align="center"
                :label="$t('stockNeed.inventoryType')"
              >
                <template slot-scope="scope">
                  {{ scope.row.lclbCommodityType | getLclbCommodityType }}
                </template>
              </el-table-column>
              <el-table-column
                prop="safetyStockQuantity"
                header-align="center"
                align="center"
                :label="$t('stockNeed.amount')"
              >
              </el-table-column>
            </el-table>
          </el-row>
          <el-form-item :label="`${$t('stockNeed.attachment')}：`" class="row attachment">
            <OssFiles :ossFiles="dataForm.xyOssFiles || []" />
          </el-form-item>
          <div class="back-wrap">
            <el-button size="medium" class="default-btn" @click="handleBack">
              {{$t('common.back')}}
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog
      :visible.sync="evaluateVisible"
      :close-on-click-modal="false"
      :before-close="cancelGoods"
      :title="dataForm.status === 6 ? $t('orderlist.btn7') : $t('evaluate.name')"
      width="1120px"
    >
      <Evaluate
        v-if="evaluateVisible"
        :signVo="dataForm.signVo"
        :evaluated="dataForm.status === 6 ? true : false"
        @cancelGoods="cancelGoods"
        @saveGoods="saveGoods"
      />
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/index'
import CurrentState from '../components/CurrentState.vue'
import BaseInfo from '../components/BaseInfo.vue'
import Evaluate from '../components/Evaluate.vue'
import OssFiles from '@/components/ossFiles/index.vue'

export default {
  filters: {
    getLclbCommodityType (val) {
      let str = ''
      let lclbCommodityType = [...(window.SITE_CONFIG.dictList.LCLB_COMMODITY_TYPE || '')]
      lclbCommodityType.some((v) => {
        if (v.code === val) {
          str = v.value
          return true
        }
        return false
      })
      return str || (val || '-')
    }
  },
  components: {
    Breadcrumb,
    CurrentState,
    BaseInfo,
    OssFiles,
    Evaluate
  },
  data () {
    return {
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.spareRequisition'),
          url: '/spareRequirementsList'
        },
        {
          label: this.$t('route.requisitionNeedDetail')
        }
      ],
      evaluateVisible: false, // 显示评价弹窗
      dataForm: {}, // 详情数据
      subLoading: false, // 按钮加载中
      cancelLoading: false
    }
  },
  created () {
    this.getDeatail()
  },
  methods: {
    // 跳转到编辑页面
    toUpdate () {
      this.$router.push({
        name: 'spareRequirementsUpdate',
        query: { id: this.$route.query.id }
      })
    },
    // 删除需求单
    handleDelete () {
      this.$confirm(`${this.$t('message.confirmDeleteRequisition')}?`, this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http
          .post(`/front/order/lclb/demand/deleteByOrdinary`, {
            demandId: this.$route.query.id
          })
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('message.delete'),
                type: 'success'
              })
              this.handleBack()
            }
          })
          .catch(() => {})
      })
    },
    // 确认需求
    handleSave () {
      if (this.subLoading) {
        return false
      }
      this.subLoading = true
      this.$http
        .post(`/front/order/lclb/demand/confirm`, {
          demandId: this.$route.query.id
        })
        .then(({ data: res }) => {
          this.subLoading = false
          if (res.code === 0) {
            this.$message.success(this.$t('message.confirmSuccess'))
            this.handleBack()
          }
        })
    },
    // 取消需求单
    handleCancel () {
      this.$confirm(this.$t('message.cancelNeed'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.cancelLoading = true
        this.$http
          .post(`/front/order/lclb/demand/cancel`, {
            demandId: this.$route.query.id
          })
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('message.cancelSuccess'),
                type: 'success'
              })
              this.handleBack()
            }
          })
          .catch(() => {})
          .finally(() => {
            this.cancelLoading = false
          })
      })
    },
    // 评价
    saveGoods (signVo) {
      const form = {
        billId: this.dataForm.demandId,
        feedbackContent: signVo.feedbackContent,
        serviceQuality: signVo.serviceQuality * 2,
        serviceFacilitate: signVo.serviceFacilitate * 2,
        serviceResponse: signVo.serviceResponse * 2
      }
      this.$http
        .post(`/front/order/lclb/demand/custSign`, form)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success(this.$t('message.evaluateSuccess'))
            this.getDeatail()
          }
          this.evaluateVisible = false
        })
        .catch(() => {
          this.evaluateVisible = false
        })
    },
    // 关闭评价弹窗
    cancelGoods () {
      this.evaluateVisible = false
    },
    // 显示评价
    pingjiaclick () {
      this.$http
        .get(`/front/order/lclb/demand/info/${this.$route.query.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataForm.signVo = res.data.signVo
            if (!this.dataForm.signVo) {
              this.dataForm.signVo = {
                serviceQuality: 5,
                serviceFacilitate: 5,
                serviceResponse: 5,
                feedbackContent: ''
              }
            } else {
              this.dataForm.signVo = {
                serviceQuality: this.dataForm.signVo.serviceQuality / 2,
                serviceFacilitate: this.dataForm.signVo.serviceFacilitate / 2,
                serviceResponse: this.dataForm.signVo.serviceResponse / 2,
                feedbackContent: this.dataForm.signVo.feedbackContent
              }
            }
          }
          this.evaluateVisible = true
        })
    },
    // 返回
    handleBack () {
      if (this.$route.query.from === 'sparePartsLibraryGoodDetail') {
        this.$router.back()
        return
      }
      this.$router.push({ name: 'spareRequirementsList' })
    },
    // 获取详细信息
    getDeatail () {
      this.$http
        .get(`/front/order/lclb/demand/info/${this.$route.query.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataForm = res.data
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  margin: 0 0 20px 0;
  font-size: 20px;
  color: #262626;
}
.title-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.demo-form-inline {
  margin-top: 10px;
}

.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-word;
}

.btns {
  display: flex;
  margin-top: 12px;
  padding: 0 0 0 59px;
}
.row {
  display: flex;
  align-items: flex-start;
  padding-top: 12px;
}
.row-opt-but {
  margin-right: 12px;
  padding: 0 12px;
  border: 1px solid #1d65a8;
  background-color: #fff;
  color: #1d65a8;
  font-size: 14px;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
  min-width: 100px;

  &:hover {
    background-color: #1d65a8;
    color: #fff;
  }
}

.back-wrap {
  display: flex;
  justify-content: center;
}

.attachment {
  /deep/ .list .item {
    line-height: inherit;
  }
}
</style>
